import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import React from "react";
import InputCheckbox from "../../input/inputCheckbox";

/** 対象不動産の借地権の譲渡 */
export default class Block4 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "021704",
        };
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">対象不動産の借地権の譲渡</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w240 dataTable-title__center" rowSpan="2">借地権譲渡についての<br></br>土地所有者(貸主)の承諾</th>
                                <td className="dataTable-body dataTable-body__w260" colSpan="2">
                                    <div className="dataTableUnit">
                                        <div className="dataTableUnit-input">
                                            <ul className="l-checkBox">
                                                <li>
                                                    <label className="checkBox">
                                                        <InputCheckbox id="ID_JYU01543" name="JYU01543" checked={this.props.pageState.JYU01543} {...params} />
                                                        <span className="checkBox-text">取得済　→　別添「承諾書」ご参照</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label className="checkBox">
                                                        <InputCheckbox id="ID_JYU01544" name="JYU01544" checked={this.props.pageState.JYU01544} {...params} />
                                                        <span className="checkBox-text">未取得（承諾料の負担者は売主です。）</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="dataTable-body dataTable-body__w260" colSpan="2">
                                    <div className="dataTableUnit">
                                        <div className="dataTableUnit-input">
                                            <ul className="l-checkBox">
                                                <li>
                                                    <label className="checkBox">
                                                        <InputCheckbox id="ID_JYU01545" name="JYU01545" checked={this.props.pageState.JYU01545} {...params} />
                                                        <span className="checkBox-text">通知可</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label className="checkBox">
                                                        <InputCheckbox id="ID_JYU01546" name="JYU01546" checked={this.props.pageState.JYU01546} {...params} />
                                                        <span className="checkBox-text">不要</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}